import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ColumnVisibilityComponent } from './column-visibility.component';

const routes: Routes = [{ path: '', component: ColumnVisibilityComponent }];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ColumnVisibilityRoutingModule { }
